/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ column: NonNullable<unknown> }} Erp_File_ColumnInputs */

const en_erp_file_column = /** @type {(inputs: Erp_File_ColumnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`File to the ERP · ${i?.column}`)
};

/**
* | output |
* | --- |
* | "File to the ERP · {column}" |
*
* @param {Erp_File_ColumnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const erp_file_column = /** @type {((inputs: Erp_File_ColumnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Erp_File_ColumnInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_erp_file_column(inputs)
});